import { render, staticRenderFns } from "./FormReposicao.vue?vue&type=template&id=45f3a7f4&"
import script from "./FormReposicao.vue?vue&type=script&lang=js&"
export * from "./FormReposicao.vue?vue&type=script&lang=js&"
import style0 from "./FormReposicao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports